import classNames from 'classnames';
import useCollapse from 'react-collapsed';

import {
  ApplicationStateDisplay,
  ApplicationState,
} from '../../../utils/enums';
import factoryLoadStaticOptions from '../../../utils/loadStaticOptions';
import TyAsyncSelect from '../../inputs/TyAsyncSelect';
import TyDateInput from '../../inputs/TyDateInput';
import TyInput from '../../inputs/TyInput';
import styles from '../Components/TyAdvancedSearchCore.module.css';
import { labelsValues } from '../Libs/enums';
import {
  loadPositionOptions,
  loadCompanyOptions,
  loadBranchofficeOptions,
  loadDepartmentOptions,
  loadShiftIdOptions,
  loadRegisteredTymberOptions,
  loadApplicationIdOptions,
  loadApplicationPrice,
  loadApplicationCredits,
} from '../Libs/loadOptions';

const getApplicationStateOptions = factoryLoadStaticOptions(
  [
    ...Object.entries(ApplicationState)
      .map(([, value]) => ({
        label: ApplicationStateDisplay[value],
        value,
      })),
    { label: 'Nepřijatá pozvánka', value: 'invitation_not_accepted' },
  ],
);

const Basic: React.FC = () => {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ defaultExpanded: true });

  return (
    <div className={styles.basic}>
      <div className={styles.triggerContainer}>
        <div {...getToggleProps()} className={styles.trigger}>
          <h2>Základní parametry</h2>
        </div>

        <div {...getToggleProps()} className={styles.trigger}>

          <div className={classNames(
            styles.triggerIcon,
            { [styles.triggerIconRotated]: isExpanded },
          )}
          />

        </div>
      </div>

      <section {...getCollapseProps()}>

        <div className={styles.row}>

          <div>
            <h3>Datum směny od - do</h3>
            <TyDateInput
              name={labelsValues.shiftDateFrom.name}
              label={labelsValues.shiftDateFrom.label}
              className={styles.tyInputs}
            />
          </div>

          <div>
            <TyDateInput
              name={labelsValues.shiftDateTo.name}
              label={labelsValues.shiftDateTo.label}
              className={styles.tyInputs}
            />
          </div>

          <div>
            <h3>Čas směny</h3>
            <TyDateInput
              name={labelsValues.shiftTimeFrom.name}
              label={labelsValues.shiftTimeFrom.label}
              className={styles.tyInputs}
              minuteStep={5}
              picker="time"
            />
          </div>

          <div>
            <TyDateInput
              name={labelsValues.shiftTimeTo.name}
              label={labelsValues.shiftTimeTo.label}
              className={styles.tyInputs}
              minuteStep={5}
              picker="time"
            />
          </div>

        </div>

        <div className={styles.row}>

          <div>
            <h3>Tymber</h3>

            <TyAsyncSelect
              loadOptions={loadRegisteredTymberOptions}
              name={labelsValues.tymber.name}
              label={labelsValues.tymber.label}
              className={styles.tyInputs}
              isClearable
              isMulti
            />

          </div>

          <div>
            <h3>Firma</h3>

            <TyAsyncSelect
              loadOptions={loadCompanyOptions}
              name={labelsValues.company.name}
              label={labelsValues.company.label}
              className={styles.tyInputs}
              isClearable
              isMulti
            />

          </div>

          <div>
            <h3>Provozovna</h3>

            <TyAsyncSelect
              loadOptions={loadBranchofficeOptions}
              name={labelsValues.branchoffice.name}
              label={labelsValues.branchoffice.label}
              className={styles.tyInputs}
              isClearable
              isMulti
            />
          </div>

          <div>
            <h3>Stav</h3>

            <TyAsyncSelect
              name={labelsValues.applicationState.name}
              label={labelsValues.applicationState.label}
              loadOptions={getApplicationStateOptions}
              isClearable
            />
          </div>

        </div>
      </section>
      <br />
    </div>
  );
};

const Other: React.FC = () => {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();

  return (
    <>
      <div className={styles.triggerContainer}>
        <div {...getToggleProps()} className={styles.trigger}>
          <h2>Ostatní parametry</h2>
        </div>

        <div {...getToggleProps()} className={styles.trigger}>

          <div className={classNames(
            styles.triggerIcon,
            { [styles.triggerIconRotated]: isExpanded },
          )}
          />

        </div>
      </div>

      <section {...getCollapseProps()}>

        <div className={styles.row}>

          <div>
            <h3>ID objednávky</h3>
            <TyAsyncSelect
              loadOptions={loadShiftIdOptions}
              name={labelsValues.orderId.name}
              label={labelsValues.orderId.label}
              className={styles.tyInputs}
              isClearable
              isMulti
            />

          </div>

          <div>
            <h3>ID směny</h3>
            <TyAsyncSelect
              loadOptions={loadApplicationIdOptions}
              name={labelsValues.applicationId.name}
              label={labelsValues.applicationId.label}
              className={styles.tyInputs}
              isClearable
              isMulti
            />

          </div>

          <div>
            <h3>Pozice</h3>
            <TyAsyncSelect
              loadOptions={loadPositionOptions}
              name={labelsValues.position.name}
              label={labelsValues.position.label}
              className={styles.tyInputs}
              isClearable
              isMulti
            />

          </div>

          <div>
            <h3>Oddělení</h3>
            <TyAsyncSelect
              loadOptions={loadDepartmentOptions}
              name={labelsValues.department.name}
              label={labelsValues.department.label}
              className={styles.tyInputs}
              isClearable
              isMulti
            />
          </div>
        </div>

        <div className={styles.row}>

          <div>
            <h3>Cena od - do</h3>
            <TyAsyncSelect
              loadOptions={loadApplicationPrice}
              name={labelsValues.applicationPriceFrom.name}
              label={labelsValues.applicationPriceFrom.label}
              className={styles.tyInputs}
              isClearable
            />
          </div>
          <div>
            <TyAsyncSelect
              loadOptions={loadApplicationPrice}
              name={labelsValues.applicationPriceTo.name}
              label={labelsValues.applicationPriceTo.label}
              className={styles.tyInputs}
              isClearable
            />
          </div>

          <div>
            <h3>Kredity od - do</h3>
            <TyAsyncSelect
              loadOptions={loadApplicationCredits}
              name={labelsValues.applicationCreditsFrom.name}
              label={labelsValues.applicationCreditsFrom.label}
              className={styles.tyInputs}
              isClearable
            />
          </div>
          <div>
            <TyAsyncSelect
              loadOptions={loadApplicationCredits}
              name={labelsValues.applicationCreditsTo.name}
              label={labelsValues.applicationCreditsTo.label}
              className={styles.tyInputs}
              isClearable
            />
          </div>
        </div>

        <div className={styles.row}>
          <div>

            <h3>Interní označení</h3>
            <TyInput
              name={labelsValues.internalName.name}
              label={labelsValues.internalName.label}
              className="w-56"
            />
          </div>
        </div>
      </section>
    </>
  );
};

const Body: React.FC = () => (
  <div className={styles.container}>
    <Basic />
    <Other />
  </div>
);

export default Body;
